import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Aside } from "../../features/home/presentation/pages/Aside";
import { Footer } from "../../features/home/presentation/pages/Footer";
import { Column } from "../components/Column";
import { HomeScreen } from "../../features/home/presentation/pages/HomeScreen";
import { FC, useEffect, useRef } from "react";
import sal from "sal.js";
import "sal.js/dist/sal.css";
import { InvitationsAndPaperwork } from "../../features/home/presentation/pages/InvitationsAndPaperwork";
import { PhotographyAndVideo } from "../../features/home/presentation/pages/PhotographyAndVideo";
import { MusicAndEntertainment } from "../../features/home/presentation/pages/MusicAndEntertainment";
import { EventCoordinators } from "../../features/home/presentation/pages/EventCoordinators";
import { Clothing } from "../../features/home/presentation/pages/Clothing";
import { DecorationAndProduction } from "../../features/home/presentation/pages/DecorationAndProduction";
import { FoodAndBeverages } from "../../features/home/presentation/pages/FoodAndBeverages";
import { Transportation } from "../../features/home/presentation/pages/Transportation";
import { Accommodations } from "../../features/home/presentation/pages/Accommodations";
import { TechAndSpecialEffects } from "../../features/home/presentation/pages/TechAndSpecialEffects";
import { AdditionalServices } from "../../features/home/presentation/pages/AdditionalServices";

type ComponentMap = {
	[key: string]: FC<{}>;
};
const componentMap: ComponentMap = {
	HomeScreen,
	InvitationsAndPaperwork,
	PhotographyAndVideo,
	MusicAndEntertainment,
	EventCoordinators,
	Clothing,
	DecorationAndProduction,
	FoodAndBeverages,
	Transportation,
	Accommodations,
	TechAndSpecialEffects,
	AdditionalServices,
};

const jsonData = {
	urls: [
		{ url: "/", name: "HomeScreen" },
		{ url: "servicios-de-invitaciones-y-papeleria", name: "InvitationsAndPaperwork" },
		{ url: "fotografia-y-video", name: "PhotographyAndVideo" },
		{ url: "musica-y-entretenimiento", name: "MusicAndEntertainment" },
		{ url: "maestros-y-coordinacion-de-eventos", name: "EventCoordinators" },
		{ url: "vestimenta", name: "Clothing" },
		{ url: "decoracion-y-produccion", name: "DecorationAndProduction" },
		{ url: "alimentos-y-bebidas", name: "FoodAndBeverages" },
		{ url: "transporte", name: "Transportation" },
		{ url: "alojamientos", name: "Accommodations" },
		{ url: "tecnologia-y-efectos-especiales", name: "TechAndSpecialEffects" },
		{ url: "servicios-adicionales", name: "AdditionalServices" },
	],
};

export const AppRouter = () => {
	return (
		<Routes>
			<Route element={<Layout />}>
				{jsonData.urls.map(({ url, name }) => {
					const Component = componentMap[name];
					return (
						<Route
							key={url}
							path={url}
							element={<Component />}
						/>
					);
				})}
			</Route>
			<Route
				path="/*"
				element={<Navigate to="/" />}
			/>
		</Routes>
	);
};

const Layout: React.FC = () => {
	const location = useLocation();
	const mainRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (mainRef.current) mainRef.current.scrollTo({ top: 0, behavior: "auto" });
		sal({
			root: null,
			once: false,
			threshold: 0.1,
		});
	}, [location.pathname]);

	return (
		<Column
			ref={mainRef}
			className="bg-[#F2E9E9] overflow-y-auto relative max-h-svh overflow-x-hidden"
		>
			<Aside />
			<Outlet />
			<Footer />
		</Column>
	);
};
